import {
  FuelStatisticAction,
  FuelStatisticState,
  SET_FUEL_STATISTIC,
  SET_FUEL_STATISTIC_FILTER,
  SET_FUEL_STATISTIC_LOADED,
} from '../types'

const initialState: FuelStatisticState = {
  fuelStatistic: [],
  isFuelStatisticLoaded: false,
  fuelStatisticFilter: {
    startTime: new Date(new Date().setDate(1)).getTime(),
    endTime: new Date().getTime(),
  },
}

export const fuelStatisticReducer = (
  state = initialState,
  action: FuelStatisticAction
): FuelStatisticState => {
  switch (action.type) {
    case SET_FUEL_STATISTIC:
      return {
        ...state,
        fuelStatistic: action.payload,
      }
    case SET_FUEL_STATISTIC_LOADED:
      return {
        ...state,
        isFuelStatisticLoaded: action.payload,
      }
    case SET_FUEL_STATISTIC_FILTER:
      return {
        ...state,
        fuelStatisticFilter: action.payload,
      }
    default:
      return state
  }
}
